/**
 * Labstep
 *
 * @module components/ResourceItem/Action/Export/Menu
 * @desc Action Menu for resource item exports
 */

import ResourceItemExportActionCreate from 'labstep-web/components/ResourceItemExport/Action/Create';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';

export const ResourceItemActionExportMenu: React.FC = () => (
  <ActionMenu>
    <ResourceItemExportActionCreate />
  </ActionMenu>
);
